import { Component } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { CommonUtilityService } from '../../../../shared/utility-services/common-utility.service';
import { ShoppingDateStateStructure } from '../../../shared/components/configs/interfaces/shopping-date.state-structure.interface';
import { DateService } from '../../../../shared/services/date.service';
import { SHOPPING_DATE_STATE_NAME } from '../../../shared/components/configs/reducers/shopping-dates.reducer';

@FormComponentLookup('adaptive-year-selector')
@Component({
    selector: 'app-adaptive-year-selector',
    templateUrl: './adaptive-year-selector.component.html',
    styleUrls: ['./adaptive-year-selector.component.scss'],
    standalone: false
})
export class AdaptiveYearSelectorComponent extends FormEntryComponentClass {

  constructor(
    private commonUtility: CommonUtilityService,
    private dateService: DateService
  ) {
    super();
  }

  ngOnInit() {
    const shoppingDatesState: ShoppingDateStateStructure = this.reducerUtilityService.getApplicationStates()[SHOPPING_DATE_STATE_NAME];

    const customShoppingDates = {
      sellThisYearProductsDate: (this.entry.custom?.sellThisYearProductsDate || shoppingDatesState.sellThisYearProductsDate) as string,
      showNextYearProductsDate: (this.entry.custom?.showNextYearProductsDate || shoppingDatesState.showNextYearProductsDate) as string,
      sellNextYearProductsDate: (this.entry.custom?.sellNextYearProductsDate || shoppingDatesState.sellNextYearProductsDate) as string
    };

    // normalize dates to the current year so we don't have to continuously update values every year. Only Month and Day will be important
    if (this.entry.custom?.shouldOnlyCompareMonthAndDay) {
      customShoppingDates.sellThisYearProductsDate = this.dateService.getDateAsCurrentYearDate(customShoppingDates.sellThisYearProductsDate);
      customShoppingDates.showNextYearProductsDate = this.dateService.getDateAsCurrentYearDate(customShoppingDates.showNextYearProductsDate);
      customShoppingDates.sellNextYearProductsDate = this.dateService.getDateAsCurrentYearDate(customShoppingDates.sellNextYearProductsDate);
    }

    let yearOptions = this.commonUtility.getYearOptionsForShoppingDates(customShoppingDates);

    this.entry.selectAttributes = {
      optionAttributes: yearOptions
    }
  }

  ngAfterViewInit(): void {
      this.initTriggers();

      // Set the default value to the first option we built in the ngOnInit method
      this.setDefaultValue(this.entry.selectAttributes.optionAttributes[0].value);
  }
}
